/* vitae · Rayleigh scattering: interactive day → firelight → full-moon scene.
   Scoped per section instance so the theme editor can duplicate it safely.
   Physics: CIE D50 daylight attenuated by Rayleigh scattering (∝ 1/λ⁴) over the
   extra air a low sun crosses, crossfading to a 1200 K firelight blackbody and
   the full moon (reflected sunlight ≈ 4100 K at 0.25 lx). MDER (melanopic ratio)
   and colour temperature are computed live. Mirrors "Rayleigh v3.html" 1:1. */
(function(){
  function initRayleigh(root){
    function $(sel){ return root.querySelector(sel); }

    // ═══ shared spectrum-column system (matches the bulb emulator / spectrum explorer) ═══
    var BAND_COLORS=["#5512b5","#3a1fd6","#2454ff","#0a8cff","#00c2d6","#15cf57","#5fd62b","#a6d61f","#ffd21f","#ffa61a",
      "#ff6e1a","#ff3b2f","#f5261e","#df1e1e","#c41e1e","#ab1a1a","#8f1818","#7a1414","#681010"]; // 420..780 / 20 nm
    var STEP=0.5;
    function crU(p0,p1,p2,p3,u){ var u2=u*u,u3=u2*u;
      return Math.max(0, 0.5*(2*p1+(-p0+p2)*u+(2*p0-5*p1+4*p2-p3)*u2+(-p0+3*p1-3*p2+p3)*u3)); }
    function resample(a){ var out=[],n=a.length,last=n-1;
      for(var t=0;t<=last+1e-9;t+=STEP){ var i=Math.min(last-1,Math.floor(t)),u=t-i;
        var v=crU(a[Math.max(0,i-1)],a[i],a[i+1],a[Math.min(last,i+2)],u);
        var hi=Math.max(0,a[i],a[i+1]); out.push(Math.min(hi,v)); }
      return out; }
    function hex2rgb(h){ return [parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)]; }
    function rgb2hex(r){ return "#"+r.map(function(v){return ("0"+Math.round(v).toString(16)).slice(-2);}).join(""); }
    function colorAt(t){ var last=BAND_COLORS.length-1,i=Math.min(last-1,Math.floor(t)),u=t-i;
      var a=hex2rgb(BAND_COLORS[i]),b=hex2rgb(BAND_COLORS[i+1]);
      return rgb2hex([a[0]+(b[0]-a[0])*u,a[1]+(b[1]-a[1])*u,a[2]+(b[2]-a[2])*u]); }
    var COLORS5=[]; for(var t5=0;t5<=(BAND_COLORS.length-1)+1e-9;t5+=STEP) COLORS5.push(colorAt(t5));
    var DWL=[]; for(var k=0;k<BAND_COLORS.length;k++) DWL.push(420+20*k); // 420..780 / 20 nm

    // ═══ CIE D50 (400–780 / 10 nm) ═══
    var D50_10=[49.31,56.51,60.03,57.82,74.82,87.25,90.61,91.37,95.11,91.96,95.72,96.61,97.13,102.10,100.75,102.32,100.00,97.74,98.92,93.50,97.69,99.27,99.04,95.72,98.86,95.67,98.19,103.00,99.13,87.38,91.60,92.89,76.85,86.51,92.58,78.23,57.69,82.92,78.27];
    function d50(l){ var f=(l-400)/10,i=Math.floor(f),t=f-i; if(i<0)return D50_10[0]; if(i>=38)return D50_10[38];
      return D50_10[i]+(D50_10[i+1]-D50_10[i])*t; }
    function planck(lamNm,T){ var l=lamNm*1e-9,h=6.626e-34,c=3e8,k=1.381e-23;
      return 1/(Math.pow(l,5)*(Math.exp(h*c/(l*k*T))-1)); }
    var FIRE_K=1200, MOON_K=4100;   // firelight blackbody · moonlight = reflected sunlight, ≈ 4100 K
    var TAU0=0.205;   // Rayleigh depth at 550 nm (exaggerated so blue & colour temp drop fast off noon)
    function tauAt(l){ return TAU0*Math.pow(550/l,4); }

    // ── display SPD (on the 19-pt band grid, resampled to the columns) ──
    var dBase=DWL.map(d50), dTau=DWL.map(tauAt), dFire=DWL.map(function(l){return planck(l,FIRE_K);});
    var refMax=Math.max.apply(null, resample(dBase));
    var fireScale=0.92*refMax/Math.max.apply(null, resample(dFire));
    // per-column wavelengths (420…780 / 10 nm): evaluate the spectrum DIRECTLY here so every column
    // moves smoothly with its neighbours (no interpolation overshoot / quirky fast columns)
    var CWL=[]; for(var ci=0;ci<COLORS5.length;ci++) CWL.push(420+10*ci);
    var cBase=CWL.map(d50), cTau=CWL.map(tauAt), cFire=CWL.map(function(l){return planck(l,FIRE_K);}), cMoon=CWL.map(function(l){return planck(l,MOON_K);});
    var cRefMax=Math.max.apply(null,cBase), cFireScale=0.2*0.94*cRefMax/Math.max.apply(null,cFire), cMoonScale=0.056*cRefMax/Math.max.apply(null,cMoon); // moon columns ~70% lower than fire

    // ═══ physics grid (400–700 / 5 nm) for MDER · CCT · blue% ═══
    var PWL=[]; for(var w=400;w<=700+1e-6;w+=5) PWL.push(w);
    var PN=PWL.length, pBase=PWL.map(d50), pBaseMax=Math.max.apply(null,pBase),
        pTau=PWL.map(tauAt), pFire=PWL.map(function(l){return planck(l,FIRE_K);}), pMoon=PWL.map(function(l){return planck(l,MOON_K);});
    function gau(x,mu,s1,s2){ var s=x<mu?s1:s2,t=(x-mu)/s; return Math.exp(-0.5*t*t); }
    var CMF=PWL.map(function(l){ return [
      1.056*gau(l,599.8,37.9,31.0)+0.362*gau(l,442.0,16.0,26.7)-0.065*gau(l,501.1,20.4,26.2),
      0.821*gau(l,568.8,46.9,40.5)+0.286*gau(l,530.9,16.3,31.1),
      1.217*gau(l,437.0,11.8,36.0)+0.681*gau(l,459.0,26.0,13.8) ]; });
    var MEL=PWL.map(function(l){ var s=l<490?42:52,t=(l-490)/s; return Math.exp(-0.5*t*t); });
    function mderRaw(spec){ var mn=0,ph=0; for(var j=0;j<PN;j++){ mn+=spec[j]*MEL[j]; ph+=spec[j]*CMF[j][1]; } return mn/(ph||1e-6); }
    var MDER_REF=mderRaw(pBase), MDER_FIRE=mderRaw(pFire)/MDER_REF, MDER_MOON=mderRaw(pMoon)/MDER_REF;
    function xyz2srgb(X,Y,Z){ var r=3.2406*X-1.5372*Y-0.4986*Z,g=-0.9689*X+1.8758*Y+0.0415*Z,b=0.0557*X-0.2040*Y+1.0570*Z;
      r=Math.max(0,r);g=Math.max(0,g);b=Math.max(0,b); var m=Math.max(r,g,b,1e-6); r/=m;g/=m;b/=m;
      function G(u){return u<=0.0031308?12.92*u:1.055*Math.pow(u,1/2.4)-0.055;}
      return [G(r)*255,G(g)*255,G(b)*255]; }
    function cctFrom(spec){ var X=0,Y=0,Z=0; for(var j=0;j<PN;j++){X+=spec[j]*CMF[j][0];Y+=spec[j]*CMF[j][1];Z+=spec[j]*CMF[j][2];}
      var s=X+Y+Z||1e-6,x=X/s,y=Y/s,n=(x-0.3320)/(0.1858-y);
      var cct=437*n*n*n+3601*n*n+6861*n+5517;
      return {cct:Math.max(1000,Math.min(7000,cct)),rgb:xyz2srgb(X/s,Y/s,Z/s)}; }

    // ═══ physical path through the atmosphere (spherical shell, far sun) ═══
    var RE=6371, HATM=20;
    function pathKm(elev){ var s=Math.sin(Math.max(0,elev)*Math.PI/180);
      return -RE*s+Math.sqrt(RE*RE*s*s+2*RE*HATM+HATM*HATM); }
    // true optical air mass (Kasten–Young): 1 at zenith → ~38 at the horizon
    function airmass(elev){ var h=Math.max(elev,0);
      return 1/(Math.sin(h*Math.PI/180)+0.50572*Math.pow(h+6.07995,-1.6364)); }

    // ═══ illuminance at the ground (order-of-magnitude honest, smooth) ═══
    function luxOf(elev,moonElev,fireI){
      var s=Math.sin(Math.max(0,elev)*Math.PI/180);
      var day=100000*Math.pow(s,1.15);                          // direct + diffuse daylight
      var twi=500*Math.pow(10,Math.min(0,elev)/2.6);            // twilight decay below the horizon
      var moon=0.25*Math.max(0,Math.sin(moonElev*Math.PI/180)); // full moon: 0.25 lx at the zenith
      return day+twi+moon+10*fireI+0.001;                       // + a small fire nearby + starlight
    }
    function fmtLux(v){
      if(v>=20000) return (Math.round(v/5000)*5000).toLocaleString('en-US');
      if(v>=1000) return (Math.round(v/100)*100).toLocaleString('en-US');
      if(v>=20) return String(Math.round(v));
      if(v>=1) return v.toFixed(1);
      return v.toFixed(2);
    }

    // ═══ DOM ═══
    var barsEl=$('[data-r="bars"]'),barEls=[];
    for(var i=0;i<COLORS5.length;i++){var b=document.createElement('div');b.className='ry-bar';b.style.background=COLORS5[i];barsEl.appendChild(b);barEls.push(b);}
    // dotted noon-reference outline behind the live bars
    (function(){ var d='',N=cBase.length;
      for(var k=0;k<N;k++){ var x=((k+0.5)/N)*100, y=100-clamp(cBase[k]/cRefMax,0,1)*100;
        d+=(k?'L':'M')+x.toFixed(2)+' '+y.toFixed(2)+' '; }
      $('[data-r="ghostPath"]').setAttribute('d',d); })();
    var mLux=$('[data-r="mLux"]'),mMder=$('[data-r="mMder"]'),mCct=$('[data-r="mCct"]'),
        mBlue=$('[data-r="mBlue"]'),srcLabel=$('[data-r="srcLabel"]'),
        verdictEl=$('[data-r="verdict"]'),verdictText=$('[data-r="verdictText"]'),
        noteEl=$('[data-r="note"]'),todName=$('[data-r="todName"]'),todSub=$('[data-r="todSub"]');

    // ═══ canvas ═══
    var scene=$('[data-r="scene"]'),cv=$('[data-r="sky"]'),ctx=cv.getContext('2d');
    var CW=0,CH=0,DPR=Math.min(2,window.devicePixelRatio||1);
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function sizeCanvas(){var r=scene.getBoundingClientRect();CW=r.width;CH=r.height;
      cv.width=Math.round(CW*DPR);cv.height=Math.round(CH*DPR);ctx.setTransform(DPR,0,0,DPR,0,0);}
    function clamp(x,a,b){return Math.max(a,Math.min(b,x));}
    function mix(a,b,t){return [a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t,a[2]+(b[2]-a[2])*t];}
    function css(c,a){return 'rgba('+(c[0]|0)+','+(c[1]|0)+','+(c[2]|0)+','+(a==null?1:a)+')';}

    // Earth centre sits well below the frame; sun, atmosphere & surface are all
    // CONCENTRIC arcs about that centre. Viewer is at the top of the surface.
    var RE_R=1.0, RSUN_R=1.44, ATM_R=0.12; // radii as multiples of CH
    var PHI_SET=Math.acos(RE_R/RSUN_R);      // orbit angle at which the sun hits the horizon
    var MOON_OFF=2*Math.PI-2*PHI_SET;        // the moon trails the sun so it SETS right at sunrise
    // true elevation seen from the viewer for ANY orbit angle (signed, full circle)
    function elevFromPhi(phi){ var dx=RSUN_R*Math.sin(phi), dy=RE_R-RSUN_R*Math.cos(phi);
      var L=Math.hypot(dx,dy)||1e-9; return Math.asin((RSUN_R*Math.cos(phi)-RE_R)/L)*180/Math.PI; }
    function geo(){
      var Re=CH*RE_R, atm=CH*ATM_R, Ra=Re+atm, Rsun=CH*RSUN_R;
      var P={x:CW*0.5, y:CH*0.56}, C={x:P.x, y:P.y+Re};
      return {C:C,P:P,Re:Re,atm:atm,Ra:Ra,Rsun:Rsun};
    }

    // grainy film layer, rendered ONCE into a CSS overlay (no per-frame canvas cost)
    (function(){ var c=document.createElement('canvas'); c.width=c.height=160;
      var g=c.getContext('2d'), id=g.createImageData(160,160), d=id.data;
      for(var i=0;i<d.length;i+=4){ var v=(Math.random()*255)|0; d[i]=d[i+1]=d[i+2]=v; d[i+3]=255; }
      g.putImageData(id,0,0);
      $('[data-r="grain"]').style.backgroundImage='url('+c.toDataURL()+')'; })();

    function dottedArc(C,R,dash,col,w){ ctx.save(); ctx.setLineDash(dash); ctx.lineWidth=w||1.4; ctx.strokeStyle=col;
      ctx.beginPath(); ctx.arc(C.x,C.y,R,-Math.PI,0,false); ctx.stroke(); ctx.restore(); }

    // a light-wave squiggle from a→b (tapered at both ends so it lands cleanly)
    function wavyPath(ax,ay,bx,by,amp,lam){ var dx=bx-ax,dy=by-ay,L=Math.hypot(dx,dy)||1,ux=dx/L,uy=dy/L,nx=-uy,ny=ux;
      ctx.beginPath(); ctx.moveTo(ax,ay);
      var n=Math.max(10,Math.round(L/5));
      for(var i=1;i<=n;i++){ var s=i/n, w=Math.sin(s*L/lam*Math.PI*2)*amp*Math.sin(Math.PI*s);
        ctx.lineTo(ax+ux*s*L+nx*w, ay+uy*s*L+ny*w); }
      ctx.stroke(); }

    function draw(st,t){ t=t||0;
      var g=geo(),C=g.C,P=g.P,Re=g.Re,Ra=g.Ra,Rsun=g.Rsun,atm=g.atm;
      var phi=st.phi, elev=st.elev, nf=st.nf;
      var S={x:C.x+Rsun*Math.sin(phi), y:C.y-Rsun*Math.cos(phi)};
      var dayK=clamp(Math.sin(clamp(elev,0,90)*Math.PI/180),0,1);
      var arrivalRGB=st.arrivalRGB||[255,248,236], blueFrac=st.blueFrac==null?1:st.blueFrac;

      ctx.clearRect(0,0,CW,CH);
      // space background: darkens into night
      var top=mix([11,15,33],[3,4,10],nf), bot=mix([16,22,42],[5,6,14],nf);
      var sg=ctx.createLinearGradient(0,0,0,CH); sg.addColorStop(0,css(top)); sg.addColorStop(1,css(bot));
      ctx.fillStyle=sg; ctx.fillRect(0,0,CW,CH);
      if(nf>0.15){ var sA=nf-0.15;
        for(var k=0;k<110;k++){ var sx=(k*137.13)%CW, sy=(k*71.31)%(CH*0.72);
          var sz=0.7+((k*29)%10)*0.13, twk=reduce?0.8:(0.55+0.45*Math.sin(t*0.001*(0.5+((k*13)%10)*0.09)+k*1.71));
          ctx.fillStyle='rgba(255,255,255,'+(0.55*sA*twk).toFixed(3)+')'; ctx.fillRect(sx,sy,sz,sz);} }

      // faint atmosphere tint between surface and the 20 km line: translucent sky-blue
      var atmCol=mix([96,165,246],[126,96,176], clamp(1-dayK,0,1));
      var rg=ctx.createRadialGradient(C.x,C.y,Re,C.x,C.y,Ra);
      rg.addColorStop(0, css(atmCol, 0.24*(0.4+0.6*dayK)+0.07)); rg.addColorStop(0.6, css(atmCol,0.10*(0.4+0.6*dayK)));
      rg.addColorStop(1, css(atmCol,0.0));
      ctx.beginPath(); ctx.arc(C.x,C.y,Ra,0,7); ctx.fillStyle=rg; ctx.fill();

      // warm twilight glow hugging the horizon near the sun
      var low=(1-clamp(Math.abs(elev)/24,0,1))*(1-nf*0.85);
      if(low>0.03){
        var hd=Math.hypot(S.x-C.x,S.y-C.y)||1, hx=C.x+(S.x-C.x)/hd*(Re+atm*0.45), hy=C.y+(S.y-C.y)/hd*(Re+atm*0.45);
        ctx.save(); ctx.beginPath(); ctx.arc(C.x,C.y,Ra,0,7); ctx.arc(C.x,C.y,Re,0,7,true); ctx.clip('evenodd');
        var hg=ctx.createRadialGradient(hx,hy,0,hx,hy,atm*7);
        hg.addColorStop(0,'rgba(255,120,40,'+(0.5*low).toFixed(3)+')');
        hg.addColorStop(0.35,'rgba(255,150,60,'+(0.22*low).toFixed(3)+')');
        hg.addColorStop(1,'rgba(255,150,60,0)');
        ctx.fillStyle=hg; ctx.fillRect(0,0,CW,CH); ctx.restore();
      }

      // concentric dotted arcs: sun's orbit + the 20 km atmosphere line
      dottedArc(C,Rsun,[2,8],'rgba(255,255,255,0.20)',1.3);
      dottedArc(C,Ra,[3,5],css(mix([120,175,240],atmCol,0.4),0.72),1.5);

      // ── the you→sun sightline, highlighting the part inside the atmosphere ──
      if(elev>=0){
        var dx=S.x-P.x, dy=S.y-P.y, dl=Math.hypot(dx,dy); dx/=dl; dy/=dl;
        var m=Re*dy+Math.sqrt(Math.max(0,Re*Re*dy*dy+Ra*Ra-Re*Re)); // ray P+m·dir ∩ atmosphere top
        var E={x:P.x+dx*m, y:P.y+dy*m};
        ctx.save(); ctx.setLineDash([5,6]); ctx.lineWidth=1.5; ctx.strokeStyle='rgba(255,255,255,0.32)';
        ctx.beginPath(); ctx.moveTo(E.x,E.y); ctx.lineTo(S.x,S.y); ctx.stroke(); ctx.restore();
        var grad=ctx.createLinearGradient(E.x,E.y,P.x,P.y);
        grad.addColorStop(0,css([255,255,255])); grad.addColorStop(0.5,css(mix([255,255,255],arrivalRGB,0.55))); grad.addColorStop(1,css(arrivalRGB));
        ctx.save(); ctx.lineCap='round'; ctx.lineJoin='round';
        ctx.strokeStyle=css(mix([255,244,214],arrivalRGB,0.5),0.24); ctx.lineWidth=11;
        ctx.beginPath(); ctx.moveTo(E.x,E.y); ctx.lineTo(P.x,P.y); ctx.stroke();
        ctx.strokeStyle=grad; ctx.lineWidth=3.6;
        wavyPath(E.x,E.y,P.x,P.y,3,26);
        ctx.restore();
        var mid={x:(E.x+P.x)/2,y:(E.y+P.y)/2}, kmTxt=Math.round(pathKm(elev))+' km of air';
        ctx.font='700 12px "Schibsted Grotesk",sans-serif'; var tw=ctx.measureText(kmTxt).width;
        var lx=clamp(mid.x+12,8,CW-tw-24), ly=clamp(mid.y-26,8,CH-30);
        ctx.fillStyle='rgba(8,10,18,0.78)';
        if(ctx.roundRect){ctx.beginPath();ctx.roundRect(lx,ly,tw+16,22,6);ctx.fill();}else ctx.fillRect(lx,ly,tw+16,22);
        ctx.fillStyle=css(mix([230,240,255],arrivalRGB,0.6)); ctx.textAlign='left'; ctx.fillText(kmTxt,lx+8,ly+15);
      }

      // ── the Earth: an earthy cap with ocean, landmasses and a hint of curvature ──
      ctx.save(); ctx.beginPath(); ctx.arc(C.x,C.y,Re,0,7); ctx.clip();
      var oceanTop=mix([100,142,196],[12,20,36],nf), oceanBot=mix([54,92,150],[6,10,19],nf);
      var og=ctx.createLinearGradient(0,P.y-CH*0.05,0,P.y+CH*0.35);
      og.addColorStop(0,css(oceanTop)); og.addColorStop(1,css(oceanBot));
      ctx.fillStyle=og; ctx.fillRect(0,0,CW,CH);
      // continents with jagged coastlines + a polar ice sheet (flat-map style, like the old diagram)
      var landCol=mix([148,172,106],[17,28,20],nf), iceCol=mix([240,246,250],[54,64,82],nf);
      // layout echoing the reference photo: one big North-America-style continent centre-left,
      // a polar ice sheet above its right shoulder, a second landmass clipped at the right edge
      var LAND=[[-0.16,2.4,1.6,0],[0.80,1.3,0.7,1]];
      var COAST=[
        [[-1,0.18],[-0.86,-0.16],[-0.62,-0.02],[-0.42,-0.3],[-0.16,-0.12],[0.08,-0.34],[0.32,-0.14],[0.56,-0.3],[0.78,-0.08],[1,-0.18],[0.94,0.12],[0.7,0.26],[0.56,0.52],[0.36,0.44],[0.3,0.7],[0.14,1],[0.04,0.64],[-0.16,0.5],[-0.42,0.56],[-0.62,0.34],[-0.82,0.46]],
        [[-1,-0.05],[-0.72,-0.32],[-0.42,-0.14],[-0.12,-0.42],[0.2,-0.22],[0.55,-0.36],[0.85,-0.1],[1,0.12],[0.7,0.36],[0.4,0.2],[0.1,0.48],[-0.25,0.28],[-0.55,0.48],[-0.82,0.22]]];
      var ICE=[[-0.55,-0.28],[-0.12,-0.5],[0.35,-0.32],[0.58,0.08],[0.28,0.42],[-0.18,0.5],[-0.48,0.16]];
      function landPath(pts,sx,sy,oy){ ctx.beginPath(); ctx.moveTo(pts[0][0]*sx,oy+pts[0][1]*sy);
        for(var q=1;q<pts.length;q++) ctx.lineTo(pts[q][0]*sx,oy+pts[q][1]*sy); ctx.closePath(); }
      for(var li=0;li<LAND.length;li++){ var fx=LAND[li][0], cx=C.x+fx*CW*0.5, dxr=cx-C.x;
        if(Math.abs(dxr)>=Re) continue;
        var surfY=C.y-Math.sqrt(Re*Re-dxr*dxr);
        ctx.save(); ctx.translate(cx,surfY); ctx.rotate(Math.atan2(dxr,C.y-surfY));
        ctx.fillStyle=css(landCol,0.95);
        landPath(COAST[LAND[li][3]], CW*0.09*LAND[li][1], CH*0.1*LAND[li][2], CH*0.026); ctx.fill();
        ctx.restore(); }
      // Greenland-style ice sheet near the top of the globe
      var icx=C.x+0.27*CW*0.5, idxr=icx-C.x;
      if(Math.abs(idxr)<Re){ var isy=C.y-Math.sqrt(Re*Re-idxr*idxr);
        ctx.save(); ctx.translate(icx,isy); ctx.rotate(Math.atan2(idxr,C.y-isy));
        ctx.fillStyle=css(iceCol,0.96); landPath(ICE, CW*0.062, CH*0.055, CH*0.018); ctx.fill(); ctx.restore(); }
      // faint latitude bands for curvature
      ctx.strokeStyle='rgba(255,255,255,0.045)'; ctx.lineWidth=1;
      for(var la=1;la<=3;la++){ ctx.beginPath(); ctx.arc(C.x,C.y,Re-la*CH*0.05,-Math.PI,0); ctx.stroke(); }
      ctx.restore();
      // ── lit hemisphere: the ground brightens toward wherever the sun is ──
      var sdx=(S.x-C.x)/Rsun, sdy=(S.y-C.y)/Rsun;
      var Gx=C.x+sdx*Re, Gy=C.y+sdy*Re;
      var lit=clamp((elev+8)/22,0,1)*(1-nf*0.92);
      if(lit>0.02){
        ctx.save(); ctx.beginPath(); ctx.arc(C.x,C.y,Re,0,7); ctx.clip(); ctx.globalCompositeOperation='lighter';
        var lg=ctx.createRadialGradient(Gx,Gy,0,Gx,Gy,Re*1.4);
        lg.addColorStop(0,css(mix([120,140,150],arrivalRGB,0.4),0.5*lit));
        lg.addColorStop(0.5,css(mix([70,90,110],arrivalRGB,0.3),0.18*lit));
        lg.addColorStop(1,'rgba(0,0,0,0)');
        ctx.fillStyle=lg; ctx.fillRect(0,0,CW,CH); ctx.restore();
      }
      // ── Earth rim light, brightest on the sun-facing side ──
      ctx.save(); ctx.globalAlpha=0.25+0.75*dayK*(1-nf);
      var rimG=ctx.createLinearGradient(S.x,S.y,2*C.x-S.x,2*C.y-S.y);
      rimG.addColorStop(0,css(mix([255,255,255],arrivalRGB,0.55),0.9));
      rimG.addColorStop(0.45,css(arrivalRGB,0.3));
      rimG.addColorStop(1,'rgba(80,110,160,0.18)');
      ctx.beginPath(); ctx.arc(C.x,C.y,Re,0,7); ctx.lineWidth=1.8; ctx.strokeStyle=rimG; ctx.stroke(); ctx.restore();

      // ── sun disc: always WHITE (fades below the horizon) ──
      if(elev>-14){ var sunA=clamp((elev+14)/16,0,1), white=[255,251,242];
        var glowR=Rsun*0.16, sd=ctx.createRadialGradient(S.x,S.y,0,S.x,S.y,glowR);
        sd.addColorStop(0,css(white,0.5*sunA)); sd.addColorStop(0.3,css(white,0.2*sunA)); sd.addColorStop(1,css(white,0));
        ctx.fillStyle=sd; ctx.beginPath(); ctx.arc(S.x,S.y,glowR,0,7); ctx.fill();
        ctx.fillStyle=css(white,sunA); ctx.beginPath(); ctx.arc(S.x,S.y,CH*0.045,0,7); ctx.fill();
        // drag-handle ring around the sun
        ctx.save(); ctx.setLineDash([3,5]); ctx.lineWidth=1.3;
        ctx.strokeStyle='rgba(255,255,255,'+(0.38*sunA).toFixed(3)+')';
        ctx.beginPath(); ctx.arc(S.x,S.y,CH*0.045+7,0,7); ctx.stroke(); ctx.restore();
      }

      // ── the full moon: rides the same orbit, timed to set right at sunrise ──
      var mphi=phi-MOON_OFF, mEl=st.moonElev==null?elevFromPhi(mphi):st.moonElev, mw=st.mf||0;
      var M={x:C.x+Rsun*Math.sin(mphi), y:C.y-Rsun*Math.cos(mphi)};
      var mA=clamp((mEl+12)/15,0,1)*clamp(nf*1.5-0.2,0,1);
      if(mA>0.02){
        // moonlight silvering the ground around the viewer
        if(mw>0.02){ ctx.save(); ctx.beginPath(); ctx.arc(C.x,C.y,Re,0,7); ctx.clip(); ctx.globalCompositeOperation='lighter';
          var mlg=ctx.createRadialGradient(P.x,P.y,0,P.x,P.y,Re*0.9);
          mlg.addColorStop(0,css([116,138,178],0.22*mw)); mlg.addColorStop(1,'rgba(0,0,0,0)');
          ctx.fillStyle=mlg; ctx.fillRect(0,0,CW,CH); ctx.restore(); }
        // moonbeam down to the viewer
        if(mEl>0){
          ctx.save(); ctx.lineCap='round'; ctx.lineJoin='round';
          ctx.strokeStyle='rgba(196,212,242,'+(0.10*mA).toFixed(3)+')'; ctx.lineWidth=8;
          ctx.beginPath(); ctx.moveTo(M.x,M.y); ctx.lineTo(P.x,P.y); ctx.stroke();
          ctx.strokeStyle='rgba(216,228,250,'+(0.55*mA).toFixed(3)+')'; ctx.lineWidth=2;
          wavyPath(M.x,M.y,P.x,P.y,2.4,26);
          ctx.restore();
          if(mw>0.45){
            var mm2={x:(M.x+P.x)/2,y:(M.y+P.y)/2}, lxTxt='0.25 lx of moonlight';
            ctx.font='700 12px "Schibsted Grotesk",sans-serif'; var tw2=ctx.measureText(lxTxt).width;
            var lx2=clamp(mm2.x+14,8,CW-tw2-24), ly2=clamp(mm2.y-26,8,CH-30);
            ctx.fillStyle='rgba(8,10,18,0.78)';
            if(ctx.roundRect){ctx.beginPath();ctx.roundRect(lx2,ly2,tw2+16,22,6);ctx.fill();}else ctx.fillRect(lx2,ly2,tw2+16,22);
            ctx.fillStyle='rgba(208,222,248,0.95)'; ctx.textAlign='left'; ctx.fillText(lxTxt,lx2+8,ly2+15);
          }
        }
        // disc, glow, craters, plus a drag ring like the sun's
        var mr=CH*0.034, mg2=ctx.createRadialGradient(M.x,M.y,0,M.x,M.y,mr*4.5);
        mg2.addColorStop(0,'rgba(205,218,246,'+(0.38*mA).toFixed(3)+')');
        mg2.addColorStop(0.4,'rgba(205,218,246,'+(0.12*mA).toFixed(3)+')');
        mg2.addColorStop(1,'rgba(205,218,246,0)');
        ctx.fillStyle=mg2; ctx.beginPath(); ctx.arc(M.x,M.y,mr*4.5,0,7); ctx.fill();
        ctx.fillStyle=css([229,234,246],mA); ctx.beginPath(); ctx.arc(M.x,M.y,mr,0,7); ctx.fill();
        ctx.fillStyle=css([204,212,233],0.9*mA);
        ctx.beginPath(); ctx.arc(M.x-mr*0.32,M.y-mr*0.22,mr*0.2,0,7); ctx.fill();
        ctx.beginPath(); ctx.arc(M.x+mr*0.26,M.y+mr*0.2,mr*0.15,0,7); ctx.fill();
        ctx.beginPath(); ctx.arc(M.x-mr*0.04,M.y+mr*0.4,mr*0.11,0,7); ctx.fill();
        ctx.save(); ctx.setLineDash([3,5]); ctx.lineWidth=1.3;
        ctx.strokeStyle='rgba(255,255,255,'+(0.3*mA).toFixed(3)+')';
        ctx.beginPath(); ctx.arc(M.x,M.y,mr+7,0,7); ctx.stroke(); ctx.restore();
      }

      // ── firelight glow at "you" after sunset (burns down as the moon climbs) ──
      var fi=st.fireI==null?nf:st.fireI;
      if(fi>0.02){
        var fl=reduce?1:(1+0.14*Math.sin(t*0.0055)+0.09*Math.sin(t*0.0115+1.7)+0.05*Math.sin(t*0.0215+0.6));
        var fr=CH*(0.035+0.02*fi)*fl, fg=ctx.createRadialGradient(P.x,P.y,0,P.x,P.y,fr);
        fg.addColorStop(0,'rgba(255,198,98,'+(0.95*fi).toFixed(3)+')');
        fg.addColorStop(0.45,'rgba(240,120,40,'+(0.55*fi).toFixed(3)+')');
        fg.addColorStop(1,'rgba(240,120,40,0)');
        ctx.fillStyle=fg; ctx.beginPath(); ctx.arc(P.x,P.y,fr,0,7); ctx.fill();
        var sway=reduce?0:Math.sin(t*0.006)*CH*0.0016;
        ctx.fillStyle='rgba(255,186,76,'+(0.95*fi).toFixed(3)+')';
        ctx.beginPath(); ctx.ellipse(P.x+sway,P.y-CH*0.006,CH*0.006,CH*0.014*fl,sway*0.06,0,7); ctx.fill();
        if(!reduce) for(var e=0;e<6;e++){ var life=((t*0.00042)+(e*0.37+0.13))%1;
          var ex=P.x+Math.sin(t*0.002+e*2.1)*CH*0.012*life, ey=P.y-CH*0.004-life*CH*0.075;
          var ea=(1-life)*fi*0.85; if(ea>0.02){ ctx.fillStyle='rgba(255,170,70,'+ea.toFixed(3)+')';
            ctx.beginPath(); ctx.arc(ex,ey,1.1+0.6*(1-life),0,7); ctx.fill(); } }
      }
    }

    // ── verdict copy ──
    function verdictOf(elev,night,rising,mw){
      if(night&&mw>0.5) return {t:'Full moon · 0.25 lx',c:'#56719F',tod:'Full moon',sub:'the moonlit night',
        note:'The fire is out; the full moon lights the ground at just <b>0.25 lx</b>, against 0.02 lx at its dimmest. Ecosystems read that tiny swing of night-blue: it paces how fast grass grows and when whole species breed.'};
      if(night) return {t:'Firelight',c:'#3f9d63',tod:'Firelight',sub:'the fire we lit at night',
        note:'The sun is down. No blue at all, just embers near 1200 K. This is the light humans spent every night under for <b>400,000 years</b>. Your clock reads it as deep night.'};
      if(elev>=45) return {t:'Peak daytime signal',c:'#c0492b',tod:'Noon',sub:'sun overhead',
        note:'The short vertical path barely touches the blue. Full D50 daylight, the strongest <b>wake</b> signal there is.'};
      if(rising){
        if(elev>=15) return {t:'Morning rising',c:'#d97a34',tod:'Morning',sub:'sun climbing',
          note:'Blue is flooding back as the path shortens; the <b>wake</b> signal is switching on for the day.'};
        if(elev>=3) return {t:'First light',c:'#c9a13a',tod:'Sunrise',sub:'sun clearing the horizon',
          note:'Warm at first, but the blue is climbing fast. Your body is reading the <b>morning</b> cue to wake.'};
        return {t:'Daybreak',c:'#b5602a',tod:'Sunrise',sub:'sun at the horizon',
          note:'Hundreds of kilometres of air still strip the blue, so first light is warm: the gentle <b>start</b> of the day.'};
      }
      if(elev>=15) return {t:'Bright afternoon',c:'#d97a34',tod:'Afternoon',sub:'sun high',
        note:'A little more air, a little less blue, still clearly a <b>daytime</b> light.'};
      if(elev>=3) return {t:'Winding down',c:'#c9a13a',tod:'Golden hour',sub:'sun getting low',
        note:'The path has grown to well over a hundred kilometres. Most of the blue is gone and the light <b>warms</b> fast.'};
      return {t:'Melatonin can rise',c:'#b5602a',tod:'Sunset',sub:'sun at the horizon',
        note:'Hundreds of kilometres of air have scattered the blue away. This is the <b>evening</b> cue your body waits for.'};
    }

    // ── slider = a full day cycle (loops seamlessly) ──
    //   The sun sweeps its orbit at a CONSTANT angular speed; the full moon rides exactly
    //   opposite, so both bodies move smoothly and evenly all the way around.
    var range=$('[data-r="range"]'), TWO_PI=Math.PI*2;
    function smoothstep(x){ x=clamp(x,0,1); return x*x*x*(x*(x*6-15)+10); }
    function stateFromP(p){
      var u=(p/1000)%1, phi=-PHI_SET+u*TWO_PI;   // u=0 → sunrise
      if(phi>Math.PI) phi-=TWO_PI;
      var elev=elevFromPhi(phi), rising=phi<0;
      var st={phi:phi, elev:elev, rising:rising, nf:clamp((2-elev)/7,0,1)};  // fire eases in from ~2° above the horizon
      st.moonElev=elevFromPhi(phi-MOON_OFF);                   // the full moon trails the sun, setting right at sunrise
      var phiN=phi<0?phi+TWO_PI:phi;
      var mRise=smoothstep((st.moonElev-8)/40);                // the moon takes over as it climbs above ~8°…
      st.mf=st.nf*(phiN>MOON_OFF?1:mRise);                     // …and HOLDS until dawn: no firelight reprise
      st.fireI=st.nf;                                           // the fire keeps burning in the scene regardless
      return st;
    }
    function pFromPhi(phiSigned){
      var u=(((phiSigned+PHI_SET)/TWO_PI)%1+1)%1;
      return Math.round(u*1000);
    }
    var cur=stateFromP(+range.value);
    // single float source of truth for the playhead — the range input quantizes values we read
    // back from it, which made resumed playback advance in visible steps (the "lag")
    var pos=+range.value;
    function setPos(p){ pos=((p%1000)+1000)%1000; range.value=pos; render(stateFromP(pos)); }

    function render(st){
      var elev=st.elev, nf=st.nf, mw=st.mf||0, fw=st.fireI==null?nf:st.fireI, mDay=airmass(elev);
      var ff=Math.max(0,fw-mw);   // for the SPECTRUM/readouts the moon supplants the fire (scene fire glow still burns)
      // ── columns: D50 attenuated per exact wavelength, crossfading to firelight / moonlight ──
      for(var k=0;k<barEls.length;k++){ var at=cBase[k]*Math.exp(-(mDay-1)*cTau[k]);
        var val=at*(1-nf)+cFire[k]*cFireScale*ff+cMoon[k]*cMoonScale*mw;
        barEls[k].style.height=(clamp(val/cRefMax,0,1)*100||0.4)+'%'; }
      // ── physics readouts ──
      var directPhys=[]; for(var j=0;j<PN;j++) directPhys[j]=pBase[j]*Math.exp(-(mDay-1)*pTau[j]);
      // colour temperature: glide smoothly to ~1900 K near the horizon (avoids McCamy wobble at extreme air mass)
      var dayCct=clamp(cctFrom(directPhys).cct,1900,7000);
      var lowSun=1-clamp(elev/6,0,1);
      dayCct=dayCct*(1-lowSun)+1900*lowSun;
      var nW=(1-nf)+ff+mw||1;
      var cctVal=Math.round((dayCct*(1-nf)+FIRE_K*ff+MOON_K*mw)/nW/10)*10;
      // stylised colour for the scene: bluest at noon → white → amber at low sun / fire
      var tc=clamp((cctVal-1900)/(6500-1900),0,1);
      var displayRGB = tc<0.5 ? mix([255,150,66],[255,248,236],tc*2) : mix([255,248,236],[150,196,255],(tc-0.5)*2);
      displayRGB=mix(displayRGB,[188,204,236],mw*0.5);   // moonlight silvers the fire-lit scene a little
      st.displayRGB=displayRGB;
      var mderVal=((mderRaw(directPhys)/MDER_REF)*(1-nf)+MDER_FIRE*ff+MDER_MOON*mw)/nW;
      var bt=0,bb=0; for(j=0;j<PN;j++){ if(PWL[j]>=440&&PWL[j]<=490){ bt+=directPhys[j]; bb+=pBase[j]; } }
      var blue=clamp((bt/bb)*(1-nf),0,1);
      mLux.textContent = fmtLux(luxOf(elev, st.moonElev==null?-90:st.moonElev, ff));
      mMder.textContent = mderVal.toFixed(2);
      mCct.textContent = cctVal;
      mBlue.textContent = Math.round(blue*100);
      srcLabel.textContent = mw>0.5?'Full moon ≈ 4100 K' : (nf>0.6?'Firelight ≈ 1200 K' : (elev<0?'Sun has set' : (mDay<1.06?'D50 daylight':'D50 after '+Math.round(pathKm(elev))+' km')));
      var v=verdictOf(elev, nf>0.5, st.rising, mw);
      verdictEl.style.setProperty('--vc',v.c);
      verdictEl.querySelector('.swatch').style.setProperty('--sw',rgbStr(displayRGB));
      verdictText.textContent=v.t; noteEl.innerHTML=v.note;
      todName.textContent=v.tod;
      st.arrivalRGB=displayRGB; st.blueFrac=blue; cur=st; draw(st,performance.now());
    }
    function rgbStr(c){return 'rgb('+(c[0]|0)+','+(c[1]|0)+','+(c[2]|0)+')';}

    // ── input wiring ──
    // manual scrub pauses the animation; drag maps the pointer angle to the day cycle
    range.addEventListener('input',function(){ interact(); pos=+range.value; render(stateFromP(pos)); });
    var dragging=false;
    function phiFromPointer(ev){
      var r=scene.getBoundingClientRect(), px=ev.clientX-r.left, py=ev.clientY-r.top;
      var g=geo(); return Math.atan2(px-g.C.x, g.C.y-py); // signed, full circle
    }
    function setFromPointer(ev){ var p=phiFromPointer(ev);
      // grab whichever body is nearer the pointer: the sun, or the full moon opposite it
      var d1=Math.abs(Math.atan2(Math.sin(p-cur.phi),Math.cos(p-cur.phi)));
      var d2=Math.abs(Math.atan2(Math.sin(p+Math.PI-cur.phi),Math.cos(p+Math.PI-cur.phi)));
      if(d2<d1){ p+=Math.PI; if(p>Math.PI) p-=2*Math.PI; }
      setPos(pFromPhi(p)); }
    scene.addEventListener('pointerdown',function(ev){ if(playBtn.contains(ev.target)) return; interact(); dragging=true; scene.setPointerCapture(ev.pointerId); setFromPointer(ev); });
    scene.addEventListener('pointermove',function(ev){ if(dragging) setFromPointer(ev); });
    scene.addEventListener('pointerup',function(){dragging=false; lastAct=performance.now();});
    scene.addEventListener('pointercancel',function(){dragging=false; lastAct=performance.now();});

    // keyboard scrubbing on the scene itself
    scene.setAttribute('tabindex','0');
    scene.setAttribute('aria-label','Time of day: drag the sun, or use the arrow keys');
    scene.addEventListener('keydown',function(ev){
      var d=0; if(ev.key==='ArrowRight'||ev.key==='ArrowUp')d=10; else if(ev.key==='ArrowLeft'||ev.key==='ArrowDown')d=-10;
      else return; ev.preventDefault(); interact();
      setPos(pos+d);
    });

    // ── play / loop ──
    var playing=false, rafId=null, lastT=0, LOOP_MS=42000;
    var playBtn=$('[data-r="play"]');
    function setIcon(){ playBtn.innerHTML = playing
      ? '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13a.7.7 0 0 0 1.06.6l10.3-6.5a.7.7 0 0 0 0-1.2L9.06 4.9A.7.7 0 0 0 8 5.5z"/></svg>'; }
    function tick(t){ if(!playing) return; if(!lastT) lastT=t; var dt=t-lastT; lastT=t;
      setPos(pos + (dt/LOOP_MS)*1000); rafId=requestAnimationFrame(tick); }
    function startPlay(){ if(playing) return; playing=true; lastT=0; setIcon(); rafId=requestAnimationFrame(tick); }
    function stopPlay(){ if(!playing) return; playing=false; if(rafId) cancelAnimationFrame(rafId); setIcon(); }
    playBtn.addEventListener('pointerdown',function(ev){ ev.stopPropagation(); });
    playBtn.addEventListener('click',function(ev){ ev.stopPropagation();
      if(playing){ userPaused=true; stopPlay(); } else { userPaused=false; cancelTween(); startPlay(); } });
    setIcon();

    // ── interaction bookkeeping: scrubs pause the loop, then it resumes on its own ──
    var lastAct=performance.now();
    function interact(){ stopPlay(); cancelTween(); lastAct=performance.now(); }

    // ── waypoint jumps: tween through the day to the chosen time (dir −1 goes backwards) ──
    var tweenId=null;
    function cancelTween(){ if(tweenId){ cancelAnimationFrame(tweenId); tweenId=null; } }
    function tweenTo(target,dir){ stopPlay(); cancelTween(); lastAct=performance.now();
      var start=pos, fwd=((target-start)%1000+1000)%1000;
      var dist=(dir<0)?fwd-1000:fwd;
      if(Math.abs(dist)<2){ setPos(target); return; }
      var dur=Math.min(2600,Math.max(600,Math.abs(dist)*2.4)), t0=performance.now();
      function step(t){ var k=clamp((t-t0)/dur,0,1); k=k<.5?2*k*k:1-Math.pow(-2*k+2,2)/2;
        setPos(start+dist*k);
        if(k<1) tweenId=requestAnimationFrame(step); else { tweenId=null; lastAct=performance.now(); } }
      tweenId=requestAnimationFrame(step); }

    // ── prev / next: step through every pill moment, paused ──
    // Daybreak · First light · Morning rising · Noon · Bright afternoon · Winding down · Sunset · Firelight · Full moon
    var PRESETS=[0,23,61,128,195,233,256,300,872];
    function stepPreset(dir){ userPaused=true; stopPlay(); cancelTween(); lastAct=performance.now();
      var v=pos, t=null, i;
      if(dir>0){ for(i=0;i<PRESETS.length;i++){ if(PRESETS[i]>v+3){ t=PRESETS[i]; break; } } if(t===null) t=PRESETS[0]; }
      else { for(i=PRESETS.length-1;i>=0;i--){ if(PRESETS[i]<v-3){ t=PRESETS[i]; break; } } if(t===null) t=PRESETS[PRESETS.length-1]; }
      tweenTo(t,dir); }
    var prevBtn=$('[data-r="prev"]'), nextBtn=$('[data-r="next"]');
    prevBtn.addEventListener('pointerdown',function(ev){ ev.stopPropagation(); });
    nextBtn.addEventListener('pointerdown',function(ev){ ev.stopPropagation(); });
    prevBtn.addEventListener('click',function(ev){ ev.stopPropagation(); stepPreset(-1); });
    nextBtn.addEventListener('click',function(ev){ ev.stopPropagation(); stepPreset(1); });

    function relayout(){ sizeCanvas(); render(cur); }
    window.addEventListener('resize',relayout);
    if('ResizeObserver' in window){ new ResizeObserver(relayout).observe(scene); }
    sizeCanvas(); render(stateFromP(+range.value));
    setTimeout(relayout,120); setTimeout(relayout,500);

    // autoplay the loop (unless the user prefers reduced motion); pause when the tab is hidden
    var userPaused=false;
    function autoKick(){ if(!reduce && !userPaused) startPlay(); }
    // ambient repaint loop: fire flicker, star twinkle, photons (skipped under reduced motion)
    var ambId=null;
    function ambStart(){ if(reduce||ambId) return; ambId=requestAnimationFrame(function loop(t){ draw(cur,t); ambId=requestAnimationFrame(loop); }); }
    function ambStop(){ if(ambId){ cancelAnimationFrame(ambId); ambId=null; } }
    document.addEventListener('visibilitychange',function(){ if(document.hidden){ stopPlay(); ambStop(); } else { ambStart(); autoKick(); } });
    ambStart();
    setTimeout(autoKick,700); window.addEventListener('load',function(){ setTimeout(autoKick,700); });
    // resume the ambient loop ~8 s after the last scrub (an explicit pause stays paused)
    setInterval(function(){ if(!playing && !userPaused && !reduce && !dragging && !tweenId
      && !document.hidden && performance.now()-lastAct>8000) startPlay(); },1000);

  }
  function boot(){
    var all=document.querySelectorAll('[data-rayleigh]');
    for(var i=0;i<all.length;i++){ if(!all[i].dataset.ryInit){ all[i].dataset.ryInit='1'; initRayleigh(all[i]); } }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();